import { Controller } from "@hotwired/stimulus";
import type DatatableController from "./datatable_controller";

export default class extends Controller<HTMLButtonElement> {
  static readonly outlets = ["datatable"];

  declare readonly hasDatatableOutlet: boolean;
  declare readonly datatableOutlet: DatatableController;

  export() {
    if (this.hasDatatableOutlet) {
      this.datatableOutlet.exportExcel();
    }
  }
}
